import { render, staticRenderFns } from "./SearchResultTitle.vue?vue&type=template&id=0e2d7d6e&"
import script from "./SearchResultTitle.vue?vue&type=script&lang=js&"
export * from "./SearchResultTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports